import { useEffect, useState } from 'react';
import '../Management.css';
import { deleteUser, getAllUsers } from '../../../http/userAPI';
import { IUserResponseModel } from '../../../interfaces/responses/IUserResponseModel';
import { Button, Modal } from 'react-bootstrap';
import moment from 'moment';

const UserManage: React.FC = () => {
    const [users, setUsers] = useState<IUserResponseModel[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState<string | null>(null);
    
    const fetchUsers = async () => {
        const result = await getAllUsers();
        if (Array.isArray(result)) {
            setUsers(result);
        } else {
            setError('Ошибка при получении пользователей');
        }
    };
    
    const handleDeleteClick = (id: string) => {
        setUserToDelete(id);
        setShowDeleteModal(true);
    };
    
    const handleDeleteConfirm = async () => {
        if (userToDelete) {
            await deleteUser(userToDelete);
            fetchUsers();
            setShowDeleteModal(false);  
            setUserToDelete(null);
        }
    };
    
    useEffect(() => {
        fetchUsers();
    }, []);
    
    return (
        <div className="manage_container">
            {error ? (
                <div>{error}</div>
            ) : (
                <table className='event_table'>
                    <thead>
                        <tr>
                            <th>ФИО</th>
                            <th>Email</th>
                            <th>Номер телефона</th>
                            <th>Почта подтверждена</th>
                            <th>Дата регистрации</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(user => (
                            <tr key={user.userId}>
                                <td>{user.lastname} {user.firstname} {user.middlename}</td>
                                <td>{user.email}</td>
                                <td>{user.phone}</td>
                                <td>{user.isEmailConfirmed ? "Подтверждена" : "Не подтверждена"}</td>
                                <td>{moment(user.createdAt).format('DD.MM.YY')}</td>
                                <td>
                                    <Button variant='danger' onClick={() => handleDeleteClick(user.userId)}>Удалить</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody> 
                </table>
            )}
            
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Подтверждение удаления</Modal.Title>
                </Modal.Header>
                <Modal.Body>Вы уверены, что хотите удалить этого пользователя?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Нет
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        Да
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UserManage;
